import { render, staticRenderFns } from "./WonderJy98.vue?vue&type=template&id=3d9a17d6"
import script from "./WonderJy98.vue?vue&type=script&lang=js"
export * from "./WonderJy98.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports